import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'


import { applePayIsSupported } from '../../Utility/Utility'

import './ButtonApplePay.scss'

/**
 * ButtonPaypal component.
 */
export const ButtonApplePay = ({ brainTreeInstancesGet, brainTreeIsInstantiated, orderUpdate, onSetError, onSetProcessing, paymentHasCompleted, values, onPaymentSelect, donationFeeRate }) => {
  const [ready, readySet] = useState(false)


  const startApplePaySession = () => {
    onSetProcessing(true)

    const totalPrice = (donationFeeRate && values.cover_donation_fee === 'Y')
    ? (parseFloat(values.payment_amount) * donationFeeRate).toFixed(2).replace('.00', '')
    : values.payment_amount;

    console.log('startApplePaySession')

    const brainTreeInstances = brainTreeInstancesGet()

    const paymentRequest = brainTreeInstances.applePayCheckoutInstance.createPaymentRequest({
      total: {
        label : 'WoodGreen',
        amount: totalPrice
      },
      requiredBillingContactFields: ["postalAddress"],
      // requiredShippingContactFields: ["name", "email"],
    });
    console.log(paymentRequest.countryCode);
    console.log(paymentRequest.currencyCode);
    console.log(paymentRequest.merchantCapabilities);
    console.log(paymentRequest.supportedNetworks);

    const session = new ApplePaySession(3, paymentRequest)

    onValidateMerchant(session)
    onPaymentAuthorized(session)
    onCancel(session)

    session.begin()
  }

  /**
   * Validate the merchant for the ApplePay session.
   *
   * @param {{}} session
   *   The current ApplePay session.
   */
  const onValidateMerchant = (session) => {
    session.onvalidatemerchant = event => {
      brainTreeInstancesGet().applePayCheckoutInstance.performValidation({
        validationURL: event.validationURL,
        displayName  : 'WoodGreen'
      })
        .then(merchantSession => {
          session.completeMerchantValidation(merchantSession)
        }).catch(validationErr => {

        // You should show an error to the user, e.g. 'Apple Pay failed to load.'
        console.error('Error validating merchant:', validationErr)
        onSetError('Apple Pay failed to load')
        onSetProcessing(false)
        session.abort()
      });
    };
  }

  // if user or browser cancells the apple payment
  const onCancel = (session) => {
    session.oncancel = event => {
      console.log('oncancel')
      onSetProcessing(false)
    }
  }

  /**
   * Carry out the post authorisation actions.
   *
   * @param {{}} session
   *   The current ApplePay session.
   */
  const onPaymentAuthorized = (session) => {
    const brainTreeInstances = brainTreeInstancesGet()

    session.onpaymentauthorized = event => {
      brainTreeInstances.applePayCheckoutInstance.tokenize(
        { token: event.payment.token},
        (tokenizeErr, payload)  => {

          if (tokenizeErr) {
            console.error('Error tokenizing Apple Pay:', tokenizeErr)
            session.completePayment(ApplePaySession.STATUS_FAILURE)
            onSetError('An unexpected error occurred, please try a different payment method.')
            return
          }

          // Send payload.nonce to your server.
          console.log('nonce:', payload.nonce);

          // If requested, address information is accessible in event.payment
          // and may also be sent to your server.
          console.log('payment event:', event)
          console.log('payment data:', event.payment)
          console.log('billingPostalCode:', event.payment.billingContact)

          // After you have transacted with the payload.nonce,
          // call `completePayment` to dismiss the Apple Pay sheet.
          session.completePayment(ApplePaySession.STATUS_SUCCESS);

          onPaymentSelect(true)

          orderUpdate({
            first_name               : event.payment['billingContact']['givenName'] ? event.payment['billingContact']['givenName'] : '',
            last_name                : event.payment['billingContact']['familyName'] ? event.payment['billingContact']['familyName'] : '',
            contact_address_line_1   : event.payment['billingContact']['addressLines'] && event.payment['billingContact']['addressLines'][0] ? event.payment['billingContact']['addressLines'][0] : '',
            contact_address_line_2   : event.payment['billingContact']['addressLines'] && event.payment['billingContact']['addressLines'][1] ? event.payment['billingContact']['addressLines'][1] : '',
            contact_address_town_city: event.payment['billingContact']['locality'] ? event.payment['billingContact']['locality'] : '',
            contact_address_post_code: event.payment['billingContact']['postalCode'] ? event.payment['billingContact']['postalCode'] : '',
            payment_client_data      : brainTreeInstances.dataCollector['deviceData'],
            payment_nonce            : payload.nonce,
            payment_provider         : 'Braintree',
            payment_method           : 'ApplePay'
          })
        })
    }
  }

  useEffect(() => {
    if (brainTreeIsInstantiated) {
      console.log('brainTreeIsInstantiated')

      if (applePayIsSupported()) {
        // This device supports version 3 of Apple Pay.
        console.log('Device ready to work with apple pay')
        readySet(true)
      }
      else {
        console.log('Not supported')
      }
    }
  }, [brainTreeIsInstantiated])

  return (
    <React.Fragment>
      {ready && !paymentHasCompleted && <button className="apple-pay-button apple-pay-button-black" onClick={startApplePaySession} /> }
    </React.Fragment>
  )
}

/**
 * ButtonPaypal PropTypes.
 */
ButtonApplePay.propTypes = {
  brainTreeIsInstantiated: PropTypes.bool,
  brainTreeInstancesGet  : PropTypes.func,
  paymentHasCompleted    : PropTypes.bool,
  onSetProcessing        : PropTypes.func,
  onSetError             : PropTypes.func,
  orderUpdate            : PropTypes.func,
  values: PropTypes.shape({
    payment_amount: PropTypes.string,
  }),
  onPaymentSelect        : PropTypes.func
}
